{
  "explorerCta": {
    "eyebrow": "<dec></dec> Explorer",
    "title": "Discover the benefits of the model with <dec></dec> Explorer",
    "body": "Quantify the results you can achieve with the DEC Energy solution in three simple steps:",
    "steps": [
      "Choose a plant from the available ones.",
      "Enter your renewable-generation target",
      "Get a quantitative analysis straight away"
    ],
    "cta": "Use DEC Explorer",
    "plantLabel": "Plant for this case"
  },
  "explorer": {
    "location": "Location",
    "peakPower": "Peak power",
    "annualProduction": "Annual production",
    "revenue": "Revenue"
  },
  "conformita": {
    "aside": {
      "note": "SBTi compliance · 10 years",
      "metric": "-20 €/MWh",
      "label": "Guarantee of Origin cost"
    },
    "hero": {
      "eyebrow": "Future-proof, profitable compliance",
      "title": "Turn the cost of compliance ",
      "highlight": "into recurring operating revenues",
      "subtitle": "By contracting plants with DEC Energy you secure the production of top-quality Guarantees of Origin. You also receive a share of the recurring revenues that makes your compliance profitable."
    },
    "sbti": {
      "steps": [
        {
          "e": "Ever stricter standards",
          "t": "Sustainability standards will demand ever greater effort",
          "d": "Each new version of SBTi brings increasingly granular requirements for temporal matching, geographic consistency and traceability."
        },
        {
          "e": "Rising costs",
          "t": "The price of high-quality Guarantees of Origin rises",
          "d": "Confirming an ESG-compliant positioning will get harder, and more and more expensive."
        },
        {
          "e": "Eliminate the cost",
          "t": "Produce your Guarantees of Origin instead of buying them",
          "d": "Sign multi-year contracts on specific SBTi-compliant renewable plants and receive the Guarantees of Origin they produce free of charge, every year."
        },
        {
          "e": "Profitable compliance with DEC Energy",
          "t": "Receive a share of the revenues and turn the cost of compliance into a gain",
          "d": "You earn a share of the revenues from the energy produced and sold by the contracted plant. The effective price of a Guarantee of Origin turns negative."
        }
      ],
      "chart": {
        "caption": "Compliant GO price, version after version",
        "market": "Compliant SBTi GO price",
        "without": "GO without DEC Energy",
        "with": "GO with DEC Energy",
        "matching": "Temporal & Geographical matching:",
        "time": "TIME",
        "zeroed": "GO cost zeroed",
        "aria": "Compliance cost curve: it rises as the standard tightens, from the least to the most stringent tiers."
      }
    },
    "proof": [
      {
        "prefix": "up to",
        "target": "− 20",
        "suffix": "€/MWh",
        "label": "negative cost per Guarantee of Origin"
      },
      {
        "target": 10,
        "suffix": "years",
        "label": "of commitment to identified plants"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "of production tracked and verifiable"
      }
    ],
    "story": {
      "heading": "A pragmatic example of future-proof, profitable compliance",
      "cards": [
        {
          "title": "Packaging company secures 10-year SBTi v2 compliance with DEC Energy",
          "body": "A European packaging company contracts a photovoltaic plant for 10 years. Its clients demand sustainability standards across the supply chain, and compliance must be demonstrated every year. By adopting the DEC Energy solution, the company, subject to SBTi, turns the cost of compliance into a recurring profit.",
          "metrics": [
            {
              "value": "- 13 €/MWh",
              "label": "negative annual GO cost"
            },
            {
              "value": "SBTi",
              "label": "SBTi compliant GO"
            }
          ]
        }
      ]
    }
  },
  "copertura-naturale": {
    "aside": {
      "note": "Price covered, no derivatives",
      "metric": "45-70%",
      "label": "volatility absorbed"
    },
    "hero": {
      "eyebrow": "Cut the volatility of your energy costs",
      "title": "Neutralise the swings in your energy cost for the",
      "highlight": "next 10 years",
      "subtitle": "Reduce energy cost volatility by earning a share of the revenues correlated with the market price of electricity. Keep buying energy from the grid: no change to your procurement, no derivatives."
    },
    "hedge": {
      "steps": [
        {
          "e": "Price volatility",
          "t": "Your electricity cost is volatile and unpredictable",
          "d": "Swings in electricity market prices make your energy procurement spend hard to estimate."
        },
        {
          "e": "Share of revenues from energy",
          "t": "Earn from the energy the plant produces and sells",
          "d": "Sign a multi-year agreement on renewable plants and secure a share of the revenues they generate. Correlated with your energy costs, they act as a natural hedge."
        },
        {
          "e": "Your net cost",
          "t": "Bill increases are offset by profits",
          "d": "When your energy costs rise, the share of the revenues generated by the plant rises too, and vice versa."
        },
        {
          "e": "Volatility neutralised",
          "t": "The result: stable costs for 10 years",
          "d": "You secure a reduction in the swings of your energy costs for the entire duration of the contract. It adds to any hedges you already have. No volume risk."
        }
      ],
      "chart": {
        "spend": "Energy cost",
        "revenue": "Asset revenue",
        "net": "Net cost",
        "year": "YEAR",
        "aria": "Energy cost, asset revenue and net cost over ten years"
      }
    },
    "proof": [
      {
        "target": "45-70",
        "suffix": "%",
        "label": "reduction in price swings"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "flexibility on your supply, left untouched"
      },
      {
        "target": 10,
        "label": "years of volatility coverage"
      }
    ],
    "story": {
      "heading": "A pragmatic case of reducing energy price volatility",
      "cards": [
        {
          "title": "Food industry company reduces energy cost volatility with DEC Energy",
          "body": "A leading Italian food industry company contracts a photovoltaic asset that sells the energy it produces at market price. The contract supplements existing hedges, and the residual swing in net cost drops significantly.",
          "metrics": [
            {
              "value": "-12.41%",
              "label": "volatility reduction in a stable energy-cost scenario"
            },
            {
              "value": "-27.94%",
              "label": "volatility reduction in an uncertain energy-cost scenario"
            }
          ]
        }
      ]
    }
  },
  "ebitda": {
    "aside": {
      "note": "EBITDA increase · 10 years",
      "metric": "20k €/GWh",
      "label": "annual operating margin"
    },
    "chart": {
      "goSaving": "GO savings",
      "energyRevenue": "Energy revenue",
      "now": "Current EBITDA",
      "withDec": "EBITDA with DEC Energy",
      "withDecShort": "EBITDA with",
      "title": "EBITDA: DEC Energy effect"
    },
    "hero": {
      "eyebrow": "Improve your operating profitability",
      "title": "",
      "highlight": "Improve EBITDA",
      "titleEnd": "by predictably cutting your energy costs",
      "subtitle": "By contracting plants with DEC Energy you eliminate the cost of Guarantees of Origin and receive recurring operating revenue. Up to €20k of extra EBITDA per contracted GWh.",
      "note": "Under the IAS/IFRS international accounting standards, the DEC Energy transaction increases EBITDA."
    },
    "pnl": {
      "steps": [
        {
          "e": "EBITDA today",
          "t": "The cost of renewable energy reduces your EBITDA",
          "d": "Buying Guarantees of Origin is a recurring, volatile operating cost line."
        },
        {
          "e": "First positive effect on EBITDA",
          "t": "Eliminate the spend on Guarantees of Origin, improve EBITDA",
          "d": "The Guarantees of Origin produced by the contracted plant are distributed to you free of charge every year, eliminating the volatile, recurring operating cost they represent."
        },
        {
          "e": "Second positive effect on EBITDA",
          "t": "Other operating revenue lifting EBITDA",
          "d": "By signing a multi-year agreement you secure recurring revenues from the energy the plant produces and sells, booked as other operating revenue."
        },
        {
          "e": "EBITDA with DEC Energy",
          "t": "The result: same energy, higher EBITDA",
          "d": "Adopting the DEC Energy solution increases operating profitability. The net effect on EBITDA is positive and structural for the entire duration of the contract."
        }
      ]
    },
    "proof": [
      {
        "prefix": "up to",
        "target": "+ 20k",
        "suffix": "€",
        "label": "EBITDA effect per GWh consumed"
      },
      {
        "target": 2,
        "label": "distinct, positive effects on EBITDA"
      },
      {
        "target": 10,
        "suffix": "years",
        "label": "of recurring operating revenue"
      }
    ],
    "story": {
      "heading": "A pragmatic example of improved operating profitability",
      "cards": [
        {
          "title": "Paper mill owned by a Private Equity fund improves EBITDA with DEC Energy",
          "body": "A European paper industry leader controlled by a Private Equity fund improves its EBITDA by signing a 10-year contract on a 7.2 MWp plant with DEC Energy. The agreement supplements the existing energy procurement without replacing it and generates a structural positive effect on EBITDA.",
          "metrics": [
            {
              "value": "+ 320 k€",
              "label": "annual EBITDA at full run-rate"
            },
            {
              "value": "+20k €/GWh",
              "label": "EBITDA per GWh consumed"
            }
          ]
        }
      ]
    }
  },
  "impatto": {
    "aside": {
      "note": "Public and verifiable impact",
      "metric": "2'500 tCO₂",
      "label": "emissions avoided, on the map"
    },
    "plantAlt": "Agrivoltaic plant: solar panels above crops",
    "hero": {
      "eyebrow": "An energy transition you can show",
      "title": "Elevate your energy transition with a solution that's",
      "highlight": "concrete and shareable",
      "subtitle": "Contract specific renewable assets and support the energy transition with a long-term commitment. Generate a positive environmental and social impact in the local area."
    },
    "profile": {
      "steps": [
        {
          "e": "An ever more attentive audience",
          "t": "Proving your sustainability will take a growing commitment",
          "d": "Your ambitious sustainability targets raise expectations year after year. Meeting them takes tools that create concrete, shareable impact."
        },
        {
          "e": "One more tool for your sustainability",
          "t": "Support the generation of new renewable energy",
          "d": "Contribute actively to the energy transition by signing multi-year agreements on specific renewable plants. Support local clean-energy production and receive your GO certificates."
        },
        {
          "e": "A commitment beyond energy",
          "t": "Where environmental and social impact meet",
          "d": "Contract plants that, beyond meeting your renewable-energy targets, create real value for people and nature."
        },
        {
          "e": "Your public profile",
          "t": "Share your concrete commitment with stakeholders",
          "d": "A virtuous, replicable model that engages your audience through a shareable, transparent, interactive page."
        }
      ],
      "card": {
        "url1": "agrivoltaico-cascina-nuova",
        "url2": "your-company",
        "company": "Your company",
        "companyTag": "Impact profile · public",
        "verified": "Verified by DEC Energy",
        "stats": ["renewable MWh this year", "CO₂ avoided", "GO retired"],
        "contractLabel": "Multi-year agreement",
        "contractMeta": "Agrivoltaico Cascina Nuova · 4.75 MWp",
        "go": "Guarantees of Origin",
        "revenue": "€ recurring revenues",
        "plantName": "Agrivoltaico Cascina Nuova",
        "plantMeta": "Vigevano (PV) · 4.75 MWp · public page",
        "props": [
          { "t": "protected harvest", "v": "hail and heat" },
          { "t": "water use", "v": "− 12'400 m³/year" },
          { "t": "crop yield", "v": "+ 20%" }
        ],
        "backed": "backed by your company",
        "foot": "One link to prove it to anyone, at zero GO cost,",
        "footEmph": "with revenues",
        "reportTitle": "Sustainability Report",
        "dials": ["renewable share", "emissions", "stakeholders"],
        "mapPlants": "plants",
        "mapRegions": "regions",
        "mapAria": "Map of central and northern Italy with three contracted plants."
      }
    },
    "proof": [
      {
        "target": 15,
        "suffix": "min",
        "label": "real-time production granularity"
      },
      {
        "target": 280,
        "suffix": "tCO₂",
        "label": "of emissions avoided per GWh produced"
      },
      {
        "target": 10,
        "suffix": "years",
        "label": "of commitment to the energy transition"
      }
    ],
    "story": {
      "heading": "A pragmatic example of sustainability in the local area",
      "cards": [
        {
          "title": "BancaStato advances concretely on the energy front with DEC Energy",
          "body": "BancaStato adopted a sustainability strategy spanning every area of its business. In the energy domain, the bank sought an additional solution to complement its current initiatives and make tangible progress on the energy front. With no trade-off between impact and profitability.",
          "metrics": [],
          "quote": {
            "text": "With this initiative we aim to help advance the integration of sustainability into corporate financial decision-making.",
            "attribution": "Luca Bordonzotti, sustainability manager at BancaStato"
          }
        }
      ]
    }
  },
  "riduzione-prevedibile": {
    "aside": {
      "note": "Reduced cost · 10 years",
      "metric": "− 24.7%",
      "label": "energy cost"
    },
    "chart": {
      "title": "Where the reduction comes from",
      "totalCosts": "Total energy costs",
      "goValue": "GO countervalue",
      "revenueShare": "Share of energy sale revenues",
      "netCost": "Net energy cost*",
      "goCost": "GO cost",
      "energyCost": "Energy cost",
      "withDec": "with DEC Energy"
    },
    "hero": {
      "eyebrow": "A predictable cut in energy costs",
      "title": "Cut your energy costs further,",
      "highlight": "predictably",
      "subtitle": "By contracting plants with DEC Energy you collect a share of the revenues from the sold energy and receive Guarantees of Origin (GO). A double cut to your current energy costs: the revenue share offsets the bill, the GO remove a cost."
    },
    "bars": {
      "steps": [
        {
          "e": "Your cost today",
          "t": "Today renewable energy is a double cost line",
          "d": "Buying energy and Guarantees of Origin is a recurring spend every renewable energy consumer has to carry."
        },
        {
          "e": "Eliminate the spend",
          "t": "With DEC Energy the cost of Guarantees of Origin goes to zero",
          "d": "Produce your Guarantees of Origin passively by contracting specific renewable plants. The GO are distributed and cancelled in your company's name. You no longer pay to buy them."
        },
        {
          "e": "Collect the revenues",
          "t": "You also earn a share of recurring, predictable revenues",
          "d": "Collect revenues from the energy produced and sold by the plant you contracted. You secure a recurring revenue for the entire duration of the agreement."
        },
        {
          "e": "The net cost with DEC Energy",
          "t": "The result: your net energy cost falls",
          "d": "Savings and proceeds together cut up to 25% of your current energy cost. Without changing your active energy supply contracts."
        }
      ]
    },
    "proof": [
      {
        "prefix": "up to",
        "target": 25,
        "suffix": "%",
        "label": "energy cost reduction"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "freedom of choice over energy supply"
      },
      {
        "target": 1,
        "suffix": "GWh",
        "label": "minimum contractable energy volume"
      }
    ],
    "story": {
      "heading": "A pragmatic example of a predictable energy cost reduction",
      "cards": [
        {
          "title": "Steel company cuts its energy costs by {24.7%} with DEC Energy",
          "body": "One of Europe's leading steel groups contracts 14.4 GWh/year of photovoltaic production through the DEC Energy model. The contract supplements the existing supply without replacing it, delivering a predictable saving on energy costs for the next 15 years.",
          "metrics": [
            {
              "value": "≈ 263 k€",
              "label": "annual operating benefit at full run-rate, EBITDA view"
            },
            {
              "value": "− 24.7%",
              "label": "renewable energy cost over 15 years"
            }
          ]
        }
      ]
    }
  }
}
